export default __webpack_public_path__ + "static/img-what-is-ml--mobile-ff648e645c151ec6cd8bff9e101dbe0a.webp";